/**
 * Texas Fungus - Review Carousel Controller
 * Standalone container decoupling, exact mathematical viewport centering,
 * fluid pointer drag with momentum physics, and square pagination.
 */

(function () {
  let isInitialized = false;

  function init() {
    if (isInitialized) return;

    const widget = document.querySelector('.reputon-google-reviews-widget') ||
                   document.querySelector('#shopify-section-template--28618477207831__1790601691aa688cfb');

    if (!widget) return;

    const oldTrack = widget.querySelector('.go4132613368, .tf-reviews-track');
    if (!oldTrack) return;

    // Collect all slide card elements
    const rawSlideElements = Array.from(oldTrack.querySelectorAll('.go3075217595, .reputon-single-review'));
    if (rawSlideElements.length === 0) return;

    // Filter to top-level slide wrappers
    const topLevelSlides = [];
    rawSlideElements.forEach((el) => {
      const wrapper = el.classList.contains('go3075217595') ? el : (el.closest('.go3075217595') || el);
      if (!topLevelSlides.includes(wrapper)) {
        topLevelSlides.push(wrapper);
      }
    });

    // Discard any swiper clone duplicates
    let nonDuplicates = topLevelSlides.filter(
      (el) => !el.classList.contains('swiper-slide-duplicate') && !el.className.includes('duplicate')
    );
    if (nonDuplicates.length === 0) {
      nonDuplicates = topLevelSlides;
    }

    // Deduplicate unique reviews by review text / reviewer name to preserve genuine order
    const uniqueCards = [];
    const seenTexts = new Set();
    nonDuplicates.forEach((el) => {
      const text = el.querySelector('.reputon-text, .reputon-top-part')?.textContent?.trim() || el.textContent.trim();
      if (text && !seenTexts.has(text)) {
        seenTexts.add(text);
        uniqueCards.push(el);
      }
    });

    if (uniqueCards.length === 0) return;

    // Sort by data-swiper-slide-index if present to guarantee Card 0 is the true first review
    if (uniqueCards.some((el) => el.hasAttribute('data-swiper-slide-index'))) {
      uniqueCards.sort((a, b) => {
        const idxA = parseInt(a.getAttribute('data-swiper-slide-index') || '0', 10);
        const idxB = parseInt(b.getAttribute('data-swiper-slide-index') || '0', 10);
        return idxA - idxB;
      });
    }

    isInitialized = true;
    setupCarousel(widget, uniqueCards);
  }

  // Poll & Observe until Reputon has rendered its slides
  document.addEventListener('DOMContentLoaded', () => {
    init();

    function suppressPopups() {
      const popups = document.querySelectorAll(
        '.reputon-google-reviews-badge-widget, .reputon-google-reviews-toast-widget, .reputon-google-reviews-popup-widget, .reputon-google-reviews-floating-widget, .reputon-badge-holder, .reputon-badge, .reputon-toast, .reputon-popup, .reputon-floating-badge, .reputon-compact-badge, [class*="reputon-badge"], [class*="reputon-toast"], [class*="reputon-popup"], [class*="reputon-floating"]'
      );
      popups.forEach((el) => {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('opacity', '0', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
      });
    }

    suppressPopups();

    const popupObserver = new MutationObserver(() => {
      suppressPopups();
    });
    popupObserver.observe(document.body, { childList: true, subtree: true });

    if (!isInitialized) {
      const observer = new MutationObserver(() => {
        const track = document.querySelector('.reputon-google-reviews-widget .go4132613368');
        if (track && track.children.length > 0) {
          observer.disconnect();
          init();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });

      // Fallback timers
      setTimeout(init, 300);
      setTimeout(init, 1000);
    }
  });

  function setupCarousel(widget, originalSlides) {
    const section = widget.closest('.shopify-section') || widget.parentElement;

    // 1. Inject Header if not present
    if (section && !section.querySelector('.tf-reviews-header')) {
      const header = document.createElement('div');
      header.className = 'tf-reviews-header';
      header.innerHTML = '<h2 class="tf-reviews-title">What Our Customers Are Saying..</h2>';
      widget.parentElement.insertBefore(header, widget);
    }

    // 2. Build our clean standalone container to permanently decouple from Reputon's internal React loop
    let container = section.querySelector('.tf-reviews-container');
    if (!container) {
      container = document.createElement('div');
      container.className = 'tf-reviews-container';
      widget.parentNode.insertBefore(container, widget);
    }
    // Hide Reputon widget completely
    widget.style.display = 'none';

    container.innerHTML = '';
    const track = document.createElement('div');
    track.className = 'tf-reviews-track';
    container.appendChild(track);

    const N = originalSlides.length;
    const gap = 20;
    const SETS = 5;
    const START_SET = 2;

    // 3. Build 5-Set Slide Array for infinite buffer
    for (let set = 0; set < SETS; set++) {
      originalSlides.forEach((slide, originalIndex) => {
        const clonedSlide = slide.cloneNode(true);
        clonedSlide.setAttribute('data-original-index', originalIndex);
        clonedSlide.style.transform = 'none';
        track.appendChild(clonedSlide);
      });
    }

    // Active starting index is START_SET * N (the first card of Set 2)
    let currentIndex = START_SET * N;
    let currentTranslate = 0;

    // 4. Inject Square Pagination Dots Container
    let pagination = section.querySelector('.tf-reviews-pagination');
    if (!pagination) {
      pagination = document.createElement('div');
      pagination.className = 'tf-reviews-pagination';
      if (container.nextSibling) {
        container.parentNode.insertBefore(pagination, container.nextSibling);
      } else {
        container.parentNode.appendChild(pagination);
      }
    }
    pagination.innerHTML = '';

    for (let i = 0; i < N; i++) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = `tf-reviews-dot ${i === 0 ? 'is-active' : ''}`;
      dot.setAttribute('aria-label', `Go to review slide ${i + 1}`);
      dot.addEventListener('click', () => {
        const currentSet = Math.floor(currentIndex / N);
        const targetIndex = currentSet * N + i;
        goToSlide(targetIndex, true);
      });
      pagination.appendChild(dot);
    }

    // 5. Geometry & Stable Container-Relative Centering (Dynamic Fluid Scaling)
    function getSlideWidth() {
      const firstSlide = track.firstElementChild;
      if (firstSlide && firstSlide.getBoundingClientRect().width > 0) {
        return firstSlide.getBoundingClientRect().width;
      }
      if (window.innerWidth <= 767) {
        return Math.max(280, document.documentElement.clientWidth - 40);
      }
      return 713;
    }

    function getGap() {
      const computed = window.getComputedStyle(track);
      return parseFloat(computed.gap) || 20;
    }

    function getOffset(index) {
      const slideW = getSlideWidth();
      const currentGap = getGap();
      const stepDist = slideW + currentGap;
      const clientW = document.documentElement.clientWidth;
      const centerPos = (clientW - slideW) / 2;

      // Use container's static position (immune to track animations)
      const containerRect = container.getBoundingClientRect();
      const containerLeft = containerRect.left;

      return centerPos - (index * stepDist) - containerLeft;
    }

    function setTransform(offset, animated = true) {
      currentTranslate = offset;
      track.style.transition = animated ? 'transform 0.45s cubic-bezier(0.22, 1, 0.36, 1)' : 'none';
      track.style.transform = `translate3d(${offset}px, 0px, 0px)`;
    }

    function updateDots(index) {
      const activeOriginalIndex = ((index % N) + N) % N;
      const dots = pagination.querySelectorAll('.tf-reviews-dot');
      dots.forEach((dot, i) => {
        if (i === activeOriginalIndex) {
          dot.classList.add('is-active');
        } else {
          dot.classList.remove('is-active');
        }
      });
    }

    function goToSlide(index, animated = true) {
      currentIndex = index;
      setTransform(getOffset(currentIndex), animated);
      updateDots(currentIndex);
    }

    // Infinite loop snap: reset position silently when outside middle range
    track.addEventListener('transitionend', (e) => {
      if (e.target !== track || e.propertyName !== 'transform') return;

      if (currentIndex < N) {
        currentIndex += 2 * N;
        setTransform(getOffset(currentIndex), false);
      } else if (currentIndex >= 4 * N) {
        currentIndex -= 2 * N;
        setTransform(getOffset(currentIndex), false);
      }
    });

    // Initial positioning (Card 0 exact center)
    goToSlide(currentIndex, false);
    requestAnimationFrame(() => {
      goToSlide(currentIndex, false);
    });

    // Recalculate on Resize
    window.addEventListener('resize', () => {
      setTransform(getOffset(currentIndex), false);
    });

    // 6. Fluid Pointer Drag Handlers (Unified Touch, Pen & Mouse with Momentum)
    let isDragging = false;
    let isMoved = false;
    let startX = 0;
    let startY = 0;
    let startTranslate = 0;
    let pointerDownTime = 0;

    function onPointerDown(e) {
      if (e.button !== 0 && e.pointerType === 'mouse') return;

      isDragging = true;
      isMoved = false;
      startX = e.clientX;
      startY = e.clientY;
      startTranslate = currentTranslate;
      pointerDownTime = Date.now();

      // Prevent native HTML5 text selection or link drag
      e.preventDefault();

      track.style.transition = 'none';
      try {
        track.setPointerCapture(e.pointerId);
      } catch (err) {}
    }

    function onPointerMove(e) {
      if (!isDragging) return;

      const diffX = e.clientX - startX;
      const diffY = e.clientY - startY;

      if (!isMoved) {
        if (Math.abs(diffX) > 4 || Math.abs(diffY) > 4) {
          if (Math.abs(diffX) >= Math.abs(diffY)) {
            isMoved = true;
          } else if (e.pointerType === 'touch') {
            // Allow vertical page scroll on touch
            isDragging = false;
            try {
              track.releasePointerCapture(e.pointerId);
            } catch (err) {}
            return;
          } else {
            isMoved = true;
          }
        }
      }

      if (isMoved) {
        e.preventDefault();
        currentTranslate = startTranslate + diffX;
        track.style.transform = `translate3d(${currentTranslate}px, 0px, 0px)`;
      }
    }

    function onPointerUp(e) {
      if (!isDragging) return;
      isDragging = false;
      try {
        track.releasePointerCapture(e.pointerId);
      } catch (err) {}

      const diffX = e.clientX - startX;
      const deltaTime = Date.now() - pointerDownTime;
      const slideW = getSlideWidth();
      const currentGap = getGap();
      const stepDist = slideW + currentGap;

      if (isMoved) {
        // Prevent accidental link opening on drag release
        const preventClick = (clickEvent) => {
          clickEvent.stopPropagation();
          clickEvent.preventDefault();
          window.removeEventListener('click', preventClick, true);
        };
        window.addEventListener('click', preventClick, true);
        setTimeout(() => {
          window.removeEventListener('click', preventClick, true);
        }, 120);

        let targetIndex = currentIndex;

        // Quick flick swipe (< 280ms and > 30px)
        if (deltaTime < 280 && Math.abs(diffX) > 30) {
          targetIndex = diffX < 0 ? currentIndex + 1 : currentIndex - 1;
        } else {
          // Snap to nearest slide based on currentTranslate
          const clientW = document.documentElement.clientWidth;
          const centerPos = (clientW - slideW) / 2;
          const containerRect = container.getBoundingClientRect();
          const containerLeft = containerRect.left;
          // currentTranslate = centerPos - (index * stepDist) - containerLeft
          // index * stepDist = centerPos - containerLeft - currentTranslate
          const exactIndex = (centerPos - containerLeft - currentTranslate) / stepDist;
          targetIndex = Math.round(exactIndex);
        }

        goToSlide(targetIndex, true);
      } else {
        goToSlide(currentIndex, true);
      }
    }

    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', onPointerUp);
    track.addEventListener('pointercancel', onPointerUp);
  }
})();

